import { gql } from '@apollo/client';

export default gql`
  mutation AddStudentsToGroup(
    $courseId: String!
    $groupId: String!
    $input: AddStudentsToGroupInput!
  ) {
    response(courseId: $courseId, groupId: $groupId, input: $input)
      @rest(
        type: "AddStudentToGroupPayload"
        path: "courses/{args.courseId}/groups/{args.groupId}/addStudents"
        method: "PUT"
      ) {
      NoResponse
    }
  }
`;
